import { Tabs, componentUtils } from '@mtfe/sweet-components';

const { getTabContainerID } = Tabs;
const { getPoiContainerID, getBottomTipID } = componentUtils;

export const storeRecallBizIdMap = {
    waimai: 'cpsWm',
    shangou: 'cpsSg',
    wmRedBag: 'cpsLimitCoupon',
    wmEveryDayCoupon: 'cpsEverDayCoupon',
    wmSelfCoupon: 'cpsSelfCoupon',
    sgRedBag: 'sgUnbindCouponMulti',
    sgEveryDayCoupon: 'sgCpsEverDayCoupon',
};

export const initPoiData = (recallBizId, giftId = '') => {
    const resData = {
        recallBizId,
        poiList: [],
        pageNo: 1,
        poiContainerID: getPoiContainerID(recallBizId, giftId),
        bottomTipID: getBottomTipID(recallBizId, giftId),
    };
    const mergeData = giftId ? { giftId, pageDivideId: giftId } : {};

    return Object.assign(resData, mergeData);
};
const initDiscountData = (recallBizId) => {
    const resData = {
        recallBizId,
        giftValue: 0,
        couponList: [],
        redBagList: [],
    };
    return resData;
};
const storeCommon = {
    phone: '',
    deviceId: '',
    structInfo: null,
    tabsInfo: null,
    isLoading: false, // 控制全局loading显示
    leftRecvNum: 0, // 剩余可领
    isShangouAct: false, // 是否是来自投放零售活动入口
};
// 已经初始化过的节点
const store = {
    treeRoot: null,
    storeCommon,
    storeWmSearch: {},
};

export const createNode = (recallBizId, tabsInfo = null) => {
    const base = {
        recallBizId, // 唯一标识ID
        // parent: null, //父节点
        // child: null, // 下级子节点
        // sibling: null, // 下一个兄弟节点
        searchKeyword: '', // 搜索关键字,只用于搜索相关store
        isShow: false, // 是否展示
        tabsInfo, // tab信息·
        tabsContainerID: getTabContainerID(recallBizId),
        poiData: initPoiData(recallBizId), // 商家列表信息
        discountData: initDiscountData(recallBizId), // 券与红包信息
    };
    store[recallBizId] = base;
    return base;
};

/**
 * 初始化树形状存储结构(未使用)
 * @param {*} currentPoint
 * @param {*} parent
 * @returns
 */
export const initStoreTree = (currentPoint) => {
    const { recallBizId, children } = currentPoint;
    if (recallBizId) {
        const currentCache = createNode(recallBizId, children);
        // currentCache.parent = parent;
        if (Array.isArray(children)) {
            let lastChild = null;
            children.forEach((child) => {
                if (lastChild) {
                    initStoreTree(child, currentCache);
                } else {
                    lastChild = initStoreTree(child, currentCache);
                }
            });
        }
        return currentCache;
    }
};
export const initStoreSearch = (struct) => {
    const { dom_wm_search: domWmSearch, dom_wm_recommend: domWmRecommend } =
        struct;
    // 搜索
    if (domWmSearch && domWmSearch.isShow) {
        createNode(domWmSearch.recallBizId);
    }
    if (domWmRecommend && domWmRecommend.isShow) {
        createNode(domWmSearch.recallBizId);
    }
};
/**
 * 深度优先搜索树(未使用)
 * @param {*} targetId 目标recallBizId
 * @param {*} node  [node = treeRoot] 从哪里开始查找,默认从根节点查找
 * @returns
 */
export const getStoreByRecallBizId = (targetId, node = store.treeRoot) => {
    const { recallBizId } = node;
    if (recallBizId === targetId) {
        return node;
    }

    if (node.child) {
        const searchRes = getStoreByRecallBizId(targetId, node.child);
        if (searchRes) {
            return searchRes;
        }
    }
    if (node.sibling) {
        const searchRes = getStoreByRecallBizId(targetId, node.sibling);
        if (searchRes) {
            return searchRes;
        }
    }
    return null;
};

const HREF = window.location.href;

if (
    HREF.includes('waimai.st.sankuai.com') ||
    HREF.includes('st.meituan.com') ||
    HREF.includes('localhost')
) {
    window.store = store;
}

export default store;
